module.exports = __webpack_public_path__ + "static/media/signal-stream.f61e8337.svg";